import { render, staticRenderFns } from "./AnnouncementBanner.vue?vue&type=template&id=bcbb0c00&"
import script from "./AnnouncementBanner.vue?vue&type=script&lang=js&"
export * from "./AnnouncementBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports